export class  Profile {

    identification: number;
    type: string;
    description: string;
}